<template xmlns:a-col="http://www.w3.org/1999/html">
    <div class="login-container">

        <a-row type="flex" justify="center" align="middle" style="height:100vh;">
            <a-col :xxl="14" :lg="20" class="shadow">
                <a-row style="height: 30vw;" type="flex" justify="center">
                    <a-col :span="12">
                        <div class="left-div">
                            <div>
                                <h1 class="text-center left-div-h">欢迎登录</h1>
                                <p class="left-div-p">牛逼的不行网络有限公司</p>
                            </div>
                        </div>
                    </a-col>
                    <a-col :span="12">
                        <div class="right-div">
                            <div style="width: 100%;padding: 40px;">
                                <div style="max-width: 400px;">
                                    <div class="right-div-form">
                                        <input type="text" placeholder="用户名" class="right-div-input"
                                               v-model="username"/>
                                    </div>
                                    <div class="right-div-form">
                                        <input type="password" class="right-div-input" placeholder="密码"
                                               v-model="password"/>
                                    </div>
                                    <a-button type="primary" block size="large" @click="login">
                                        登录
                                    </a-button>
                                </div>
                            </div>
                        </div>
                    </a-col>
                </a-row>
            </a-col>
        </a-row>
    </div>
</template>

<script>
import 'ant-design-vue/dist/antd.css';
import axios from "axios";

export default {
    name: "Login",
    data: function () {
        return {
            username: '',
            password: '',
            spinning: false,
        };
    },
    methods: {
        login: function () {
            let that = this;
            axios.post(this.$host + "/admin/login", {
                username: this.username,
                password: this.password
            }).then(function (res) {
                if (res.data.status === true) {
                    localStorage.setItem("token", res.data.data);
                    that.$message.info('登录成功');
                    let loginFrom = localStorage.getItem("loginFrom");
                    if (loginFrom !== null && loginFrom !== undefined) {
                        localStorage.removeItem("loginFrom");
                        window.location.href = loginFrom;
                    } else {
                        that.$router.push({path: "/"});
                    }
                } else {
                    that.$message.info(res.data.msg);
                }
            }).catch(function (err) {
                console.log(err)
            });
        }
    }
}
</script>

<style scoped>
body {
    font-family: "Poppins", sans-serif;
}

.login-container {

}

.login-container::before {
    content: '';
    filter: blur(10px);
    -webkit-filter: blur(10px);
    background: url(./assets/p_big3.jpg);
    background-size: cover;
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    right: 0;
}

.shadow {
    border-radius: 5px;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1), -1px 0 2px rgba(0, 0, 0, 0.05);
    -webkit-box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1), -1px 0 2px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    /*border: 5px solid red;*/
}

.left-div {
    background: rgba(121, 106, 238, 0.9);
    color: #fff;
    height: 100%;
    align-items: center !important;
    display: flex !important;
    justify-content: center;
}

.left-div-h {
    font-size: 2.5em;
    font-weight: 600;
    color: #fff;
}

.left-div-p {
    font-size: 1.2em;
}

.right-div {
    background-color: white;
    height: 100%;
    align-items: center !important;
    display: flex !important;
}

.right-div-form {
    margin-bottom: 30px;
}

.right-div-input {
    border: none;
    border-bottom: 1px solid #eee;
    padding: 10px 0;
    outline: none !important;
    display: block;
    width: 100%;
    font-size: 1.2em;
}

.right-div-input:focus {
    border-color: #796AEE;
}

.ant-btn {
    font-family: "Poppins", sans-serif;
}

.text-center {
    text-align: center;
}

</style>